export const statusProvider = {
  Unpaid: ['Unpaid', 'unpaid'],
  Overdue: ['Overdue', 'overdue'],
  Paid: ['Paid', 'paid'],
};

export const excludedHeaders = ['tags', 'status'];
